import type {TextQuestion, SurveyHandler, SurveyError} from 'src/types/survey';
// @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'Answer'. Did you mean to use 'import Answer from "src/api-parsers/events"' instead?
import type {Answer} from 'src/api-parsers/events';

import * as React from 'react';
import moment from 'moment';

import {useWindowWidth} from 'src/flux/responsive';
import {checkDateInputSupport} from 'src/utils/dom';

import Loading from 'src/components/lib/loading/loading';
import CalendarIcon from 'src/images/calendar-icon.svg';

import css from './calendar-date.css';


const buttonClass = css.submitButton.split(' ')[0];
// TODO: find a way to do this without splitting an imported class and using the style tag

type Props = {
  data: TextQuestion;
  response?: Answer;
  handleNext: SurveyHandler;
  buttonColor: string;
  currentError: SurveyError;
  audienceVariables: {
    [key: string]: string | null | undefined;
  };
  atsFieldWritebackEnabled: boolean;
  fetching: boolean;
};

export default function CalendarDate(
  props: Props,
): React.ReactElement<React.ComponentProps<'div'>> {
  const {
    data,
    response,
    handleNext,
    buttonColor,
    currentError,
    audienceVariables,
    atsFieldWritebackEnabled,
    fetching,
  } = props;

  const {isMobileWindow} = useWindowWidth();

  const writebackPrefillEnabled =
    atsFieldWritebackEnabled &&
    data.writeback?.show_current_value &&
    data.writeback?.attribute_name;
  const writebackPrefill =
    writebackPrefillEnabled &&
    // @ts-expect-error - TS18048 - 'data.writeback' is possibly 'undefined'. | TS2538 - Type 'undefined' cannot be used as an index type.
    audienceVariables?.[data.writeback.attribute_name];
  const prefill = response?.moduleValue || writebackPrefill || '';

  const [selectedDate, setSelectedDate] = React.useState(prefill);
  const [dateError, setDateError] = React.useState<any>(null);
  const [supportsDateInput, setSupportsDateInput] = React.useState(false);

  React.useEffect(() => {
    setSelectedDate(prefill);
  }, [prefill]);

  React.useEffect(() => {
    setSupportsDateInput(checkDateInputSupport());
  }, []);

  return (
    <div className={css.dateSurvey}>
      <p className={css.dateSurveyText}>
        {data.question}
        {data.required && ' *'}
      </p>
      {currentError && (
        <p className={css.dateSurveyError}>{currentError.message}</p>
      )}
      {dateError && <p className={css.dateSurveyError}>{dateError}</p>}
      <div className={css.dateWrapper}>
        {fetching ? (
          <Loading />
        ) : (
          <div className={css.datePicker}>
            <input
              type={supportsDateInput ? 'date' : undefined}
              placeholder={supportsDateInput ? '' : 'YYYY-MM-DD'}
              max="3000-01-01"
              min="1000-01-01"
              disabled={fetching}
              className={css.dateInput}
              value={selectedDate}
              onChange={(e) => {
                setSelectedDate(e.target.value);
              }}
              required
            />

            {supportsDateInput && !isMobileWindow && (
              <span className={css.calendarIconContainer}>
                <CalendarIcon className={css.calendarIcon} />
              </span>
            )}
          </div>
        )}
      </div>
      <button
        className={css.submitButton}
        // @ts-expect-error - TS2322 - Type '(evt: Event) => void' is not assignable to type 'MouseEventHandler<HTMLButtonElement>'.
        onClick={(evt: Event) => {
          evt.preventDefault();
          const isValidDate =
            moment(selectedDate).format('YYYY-MM-DD') === selectedDate;
          const canSkipValidation = !data.required && !selectedDate;

          if (isValidDate || canSkipValidation) {
            handleNext(selectedDate);
          } else {
            setDateError('Please enter a valid date');
          }
        }}
      >
        Submit
      </button>
      {buttonColor && (
        <style>{`
          .${buttonClass} {
            background-color: ${buttonColor};
            border-color: ${buttonColor};
          }
          .${buttonClass}:hover {color: ${buttonColor};}
        `}</style>
      )}
    </div>
  );
}
